import { ReactNode } from 'react'
import { useDirection } from '@hooks/useDirection'

/**
 * Root wrapper that manages document dir/lang attributes.
 * Must be rendered inside React tree (needs hooks).
 */
export function I18nRoot({ children }: { children: ReactNode }) {
  useDirection()
  return <>{children}</>
}
